import { IsMobileDevice } from "../../../../../domain/Device/Helpers/IsMobile";
import SoundManager from "source/app/services/Sound/SoundManager";
import GetMultipliedKips from "../MultiplyKips";
import { ShowLogEntryPopup } from "../ShowLogEntryPopup";

export function OrchestrateLogEntryPopup(inputValues: string[]) {
    let initialKipsValue = parseInt(inputValues[1]);

    if (initialKipsValue <= 0) {
        return;
    }

    const multipliedKips = GetMultipliedKips(initialKipsValue);

    inputValues[1] = multipliedKips.finalKips.toString();

    ShowLogEntryPopup(multipliedKips);
    multipliedKips.sound?.Play();
    // PlayEntrySignificanceSound(inputValues[0]);
}

// function PlayEntrySignificanceSound(entry: string) {
//     if (entry === undefined) {
//         throw new Error("Cannot read the entry: " + entry);
//     }

//     var soundFileId = SoundManager.GetFileId(entry);
//     var soundFilePath = SoundManager.GetFilePath(soundFileId);

//     if (IsMobileDevice()) {
//         return;
//     }


//     SoundManager.GetHowl({ path: soundFilePath }).play();
// }
